import { format } from 'date-fns'
import { InteractionRequiredAuthError, SilentRequest } from '@azure/msal-browser'
import { UpdateStoreHelperJournal } from '../../source/StoreHelperJournal'

export const updateJournal = (
    date: string,
    instance: any,
    accessTokenRequest: SilentRequest,
    dispatch: any,
    setLoadingDate: any,
) => {
    instance
    .acquireTokenSilent(accessTokenRequest)
    .then((accessTokenResponse: any) => {
        const accessToken: string = accessTokenResponse.accessToken
        UpdateStoreHelperJournal(format(date, 'yyyy-MM-dd'), accessToken)
    })
    .catch((error: any) => {
        if (error instanceof InteractionRequiredAuthError) {
            return instance.acquireTokenRedirect(accessTokenRequest)
        }
        console.log(error)
        dispatch(setLoadingDate(false))
    })
}
